export async function base64ToUtf8(b64) {
  const s = normalizeB64(b64);
  const res = await fetch(`data:application/octet-stream;base64,${s}`);
  const buf = await res.arrayBuffer();
  return new TextDecoder("utf-8").decode(buf);
}

function normalizeB64(b64) {
  // supporta anche base64url ( -_ ) e padding mancante
  let s = String(b64).replace(/-/g, "+").replace(/_/g, "/");
  const pad = s.length % 4;
  if (pad) s += "=".repeat(4 - pad);
  return s;
}